<section [appStoryblokEditable]="_editable" *ngIf="content?.length && COMPONENTS && isFirstPage">
  <div *ngFor="let blok of content" [appStoryblokEditable]="blok._editable">
    <ndc-dynamic [ndcDynamicComponent]="COMPONENTS[blok.component]" [ndcDynamicInputs]="buildInputs(blok)"> </ndc-dynamic>
  </div>
</section>
